export default __webpack_public_path__ + "static/media/photo.1fc88198.jpg";